import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { letterFrequencies, trigramFrequencies, bigramFrequencies } from '../../../assets/constant';
import { ImageEditorComponent } from '../image-editor/image-editor.component';
import { CompressionService } from '../compression.service';
import { HttpClient } from '@angular/common/http';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.css']
})
export class PlaygroundComponent extends GeneralComponent {

  exerciseType: string = "";

  solved = false;


  compressedText: string = "";

  // Images
  @ViewChild('imageEditor', {static:true}) imageEditor: ImageEditorComponent;
  @ViewChild('imageSolutionEditor', {static:true}) imageSolutionEditor: ImageEditorComponent;

  colors: string = "bw";
  highlight: boolean = true;
  image: string[][] = [];
  current: number[] = [0, 0];

  errors: number[][] | number[] = [];

  caretPosition: number;
  position: number[] = [];

  lower: number;
  upper: number;

  requirement: string = "";
  showCompressed: boolean = true;
  requiredColor: string = "";
  cImage: string[][];
  errorsCC: string[] = [];

  //Compression
  text: string = "";
  studentText: string = "";
  absolute: boolean = false;
  relative: boolean = false;

  possibleTexts: string[] = [];
  toHighlight: number[] = [];

  mapping: any[][] = [["", ""], ["", ""], ["", ""], ["", ""]];

  get map0(): string[] {
    return this.mapping.map(v => v[0]);
  }

  get map1(): string[] {
    return this.mapping.map(v => v[1]);
  }

  modus: string;
  showTree: boolean = false;

  nodes: any[];
  edges: any[];

  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveBundle;

  greyOut: boolean = false;
  prefixes: string[] = [];
  get codes(): string[] {
    return this.mapping.map(v => v[2]);
  }



  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;
  constructor(topicService: TopicService, protected messageService: MessageService, protected compressionService: CompressionService, protected http: HttpClient) {
    super(topicService);
    this.loadText();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(textFile)
        .subscribe(response => {
          self.possibleTexts = response.repeatedTexts;
          console.log(self.possibleTexts)
          resolve(true);
        })
    })
  }


  reset() {
    this.solved = false;


    this.compressedText = "";


    this.colors = "bw";
    this.highlight = true;
    this.image = [];
    this.current = [0, 0];

    this.errors = [];

    this.caretPosition = 0;
    this.position = [];

    this.lower = undefined;
    this.upper = undefined;

    this.requirement = "";
    this.showCompressed = true;
    this.requiredColor = "";
    this.cImage = [];
    this.errorsCC = [];

    //Compression
    this.text = "";
    this.studentText = "";
    this.absolute = false;
    this.relative = false;

    this.toHighlight = [];

    this.mapping = [["", ""], ["", ""], ["", ""], ["", ""]];


    this.modus = "";
    this.showTree = false;

    this.nodes = undefined;
    this.edges = undefined;


    this.greyOut = false;
    this.prefixes = [];

  }

  generate() {
    this.solved = false;
    this.reset();
    switch (this.exerciseType) {
      case "imageCompression": this.generateImageCompression(); break;
      case "newImageCompression": this.generateNewImageCompression(); break;
      case "newImageDecompression": this.generateNewImageCompression(); break;
      case "createImages": this.generateCreateImages(); break;
      case "wordCompression": this.generateWordCompression(); break;
      case "wordDecompression": this.generateWordCompression(); this.compressedText = this.compressionService.compress(this.text, this.absolute, this.relative); break;
      case "letterCompression": this.generateLetterCompression(); break;
      case "letterDecompression": this.generateLetterCompression(); break;
      case "createCompression": this.generateCreateCompression(); break;
    }

  }

  generateImageCompression() {
    this.colors = "bw";
    this.imageEditor.colors = "bw";
    this.image = this.imageEditor.possibleImages[Math.floor(Math.random() * this.imageEditor.possibleImages.length)];
    this.imageEditor.setImage(this.image);
    this.highlight = true;
    this.imageChanged(this.image);
  }

  generateNewImageCompression() {
    this.colors = Math.random() > 0.5 ? "bw" : "cmyrgb";
    this.imageEditor.colors = this.colors;
    this.highlight = Math.random() > 0.5;
    this.image = this.imageEditor.possibleImages[Math.floor(Math.random() * this.imageEditor.possibleImages.length)];
    this.imageEditor.setImage(this.image);
    this.imageChanged(this.image);

  }

  generateCreateImages() {
    this.requirement = Math.random() > 0.5 ? "uni" : "unchanged";
    if (this.requirement == "uni") {
      switch (Math.floor(Math.random() * 5)) {
        case 0: this.requiredColor = "w"; break;
        case 1: this.requiredColor = "k"; break;
        case 2: this.requiredColor = "r"; break;
        case 3: this.requiredColor = "g"; break;
        case 4: this.requiredColor = "b"; break;
      }
      this.colors = (this.requiredColor == "w" || this.requiredColor == "k") ? "bw" : "cmy";
      this.image = this.imageSolutionEditor.getImage();
    } else {
      this.colors = Math.random() > 0.5 ? "bw" : "cmy";
    }



    this.recomputeImage();
  }


  //Images

  checkSolutionImageCompression() {
    let solution = this.compressedImage();
    let studentimage = this.imageSolutionEditor.getImage();
    let temp_errors = studentimage.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => u[0] != solution[+u[1]][+u[2]]).map(u => [+u[1], +u[2]]));
    this.errors = [].concat(...temp_errors);
    temp_errors = (<number[][]>this.errors).map(v => [[2 * v[0], 2 * v[1]], [2 * v[0] + 1, 2 * v[1]], [2 * v[0], 2 * v[1] + 1], [2 * v[0] + 1, 2 * v[1] + 1]]);
    this.errors = [].concat(...temp_errors);
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }


  compressedImage() {
    let image = [];
    for (let i = 0; i < 10; i++) {
      let row = [];
      for (let j = 0; j < 10; j++) {
        let square = [];
        square.push(this.image[i * 2][j * 2]);
        square.push(this.image[i * 2 + 1][j * 2]);
        square.push(this.image[i * 2][j * 2 + 1]);
        square.push(this.image[i * 2 + 1][j * 2 + 1]);
        if (this.colors == "bw") {
          square = square.filter(v => v == "k");
          if (square.length >= 2) {
            row.push("k");
          } else {
            row.push("w");
          }
        } else {
          if (square.includes('c') && square.includes('m') && square.includes('y')) {
            row.push("k");
          } else if (square.includes('c') && square.includes('y')) {
            row.push("g");
          } else if (square.includes('c') && square.includes('m')) {
            row.push("b");
          } else if (square.includes('y') && square.includes('m')) {
            row.push("r");
          } else if (square.includes('c')) {
            row.push("c");
          } else if (square.includes('m')) {
            row.push("m");
          } else if (square.includes('y')) {
            row.push("y");
          }

        }
      }
      image.push(row);
    }



    return image;
  }

  checkSolutionNewImageCompression() {
    let imageString = this.image.map(v => v.join("")).join("");

    let lastSign = "";
    let count = 0;
    let solution = "";
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }
    solution = solution.concat(count.toString(), lastSign);

    let counts = this.compressedText.split(/([0-9]+)/);
    let studentImage = "";

    for (let i = 1; i < counts.length; i += 2) {
      studentImage = studentImage.concat(counts[i + 1].repeat(+counts[i]));
    }

    this.errors = [];
    if (imageString != studentImage) {
      this.messageService.addAlertWithTimeout(this.get("wrongImage"), "danger", 10000);
      this.errors = imageString.split("").map((v, i) => [v, i]).filter(v => v[0] != studentImage.charAt(+v[1])).map(v => v[1]).map(v => [Math.floor(+v / 20), +v % 20]);
      return;
    }

    if (this.compressedText != solution) {
      this.messageService.addAlertWithTimeout(this.get("wrongImageCompression"), "danger", 10000);
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    this.solved = true;

  }

  checkSolutionNewImageDecompression() {
    console.log("hello");
    let counts = this.compressedText.split(/([0-9]+)/);
    let solution = "";

    for (let i = 1; i < counts.length; i += 2) {
      solution = solution.concat(counts[i + 1].repeat(+counts[i]));
    }

    let image = this.imageSolutionEditor.getImage();

    let temp_error = image.map((v, i) => (v.map((u, j) => [u, i, j]).filter(u => u[0] != solution.charAt(+u[1] * 20 + +u[2])).map(u => [u[1], u[2]])));
    this.errors = [].concat(...temp_error);
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }

  checkSolutionCreateImages() {
    let firstColor = this.image[0][0];
    if (this.image.map(v => v.filter(u => u != firstColor)).filter(v => v.length != 0).length == 0) {
      this.messageService.addAlertWithTimeout(this.get("doNotUseOneColor"), "danger", 10000);
      return;
    }
    if (this.requirement == 'uni') {
      let temp_errors = this.image.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => this.color(this.cImage[Math.floor(+u[1] / 2)][Math.floor(+u[2] / 2)].toString()) != this.requiredColor).map(u => [Math.floor(+u[1]), Math.floor(+u[2])]));
      this.errors = [].concat(...temp_errors);
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.solved = true;
      }
    } else {

      let temp_errors = this.image.map((v, i) => v.map((u, j) => [u, i, j]).filter(u => u[0] != this.cImage[Math.floor(+u[1] / 2)][Math.floor(+u[2] / 2)]).map(u => [+u[1], +u[2]]));
      this.errors = [].concat(...temp_errors);
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectYet"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.solved = true;
      }
    }
  }

  checkSolutionWordCompression() {
    let solution = this.compressionService.compress(this.text, this.absolute, this.relative);
    let studentSolution = this.compressedText;
    let studentDecompressed = this.compressionService.decompress(studentSolution).split(" ");

    console.log(studentDecompressed);

    this.errors = this.text.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentDecompressed[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      if (studentSolution.length > solution.length) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v[0].toString().length < studentSolution.split(" ")[v[1]].length).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("notMinimalCompression"), "danger", 10000);
      } else if ((!this.relative && studentSolution.includes("+"))) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("+")).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("wrongCompressionUsedRelative"), "danger", 10000);
      } else if ((!this.absolute && studentSolution.includes("#"))) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("#")).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("wrongCompressionUsedAbsolute"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.solved = true;
      }
    }

  }

  checkSolutionWordDecompression() {
    let solution = this.compressionService.decompress(this.compressedText);
    let studentSolution = this.studentText.split(" ");
    this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }

  checkSolutionLetterCompression() {
    let solution = this.compressionService.compressLetter(this.text, this.mapping);
    let studentSolution = this.compressedText.split("");
    this.errors = solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]).map(v => this.position[v]);


    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }

  checkSolutionLetterDecompression() {
    let solution = this.compressedText;
    let studentSolution = this.compressionService.compressLetter(this.studentText, this.mapping);
    this.errors = solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }

  checkSolutionCreateCompression() {
    let mapping_temp = [...this.mapping];
    mapping_temp.sort((a, b) => +a[1] - +b[1]);
    console.log(mapping_temp);

    let error = false;


    this.errorsCC = this.mapping.filter(m => m[2] == "" || m[2] == undefined).map(m => m[0]);

    if (this.errorsCC.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCompletlyFilled"), "danger", 10000);
      return;
    }

    this.errorsCC = [];

    //check for prefix-freedom
    for (let i = 0; i < mapping_temp.length; i++) {
      for (let j = 0; j < mapping_temp.length; j++) {
        if (i != j && mapping_temp[i][2].startsWith(mapping_temp[j][2])) {
          error = true;
          this.errorsCC.push(mapping_temp[i][0], mapping_temp[j][0]);
        }
      }
    }

    if (error) {
      this.messageService.addAlertWithTimeout(this.get("notPrefixFree"), "danger", 10000);
      return;
    }

    //check for increasing code length
    for (let i = 0; i < this.mapping.length; i++) {
      for (let j = 0; j < i; j++) {
        if (this.mapping[i][1] < this.mapping[j][1] && this.mapping[i][2].length < this.mapping[j][2].length) {
          error = true;
          this.errorsCC.push(this.mapping[i][0], this.mapping[j][0]);
        }
      }
    }

    if (error) {
      this.messageService.addAlertWithTimeout(this.get("lessFrequentLonger"), "danger", 10000);
      return;
    }

    //check for maximal code length
    for (let i = 0; i < this.mapping.length; i++) {
      console.log(Math.ceil(Math.log2(100 / (+this.mapping[i][1]))))
      if (this.mapping[i][2].length > Math.ceil(Math.log2(100 / (+this.mapping[i][1])))) {
        error = true;
        this.errorsCC.push(this.mapping[i][0]);
      }
    }

    if (error) {
      this.messageService.addAlertWithTimeout(this.get("longerThanNeeded"), "danger", 10000);
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    this.solved = true;


  }

  imageChanged(event) {
    this.image = event;
    if (this.exerciseType == "newImageDecompression") {
      this.compressImage();
    }
  }

  compressImage() {
    let imageString = this.image.map(v => v.join("")).join("");
    let lastSign = "";
    let count = 0;

    let solution = "";
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }

    solution = solution.concat(count.toString(), lastSign);
    this.compressedText = solution;

    let counts = this.compressedText.split(/([0-9]+)/);

    let presum = 0;
    this.position = [];
    for (let i = 0; i < counts.length; i++) {
      if (Number.isNaN(+counts[i])) {
        this.position.push(presum);
      } else {
        presum += +counts[i];
        for (let j = 0; j < counts[i].length; j++) {
          this.position.push(presum);
        }
      }
    }
  }

  recomputeImage() {
    this.cImage = this.compressedImage();
  }

  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }
    if (this.exerciseType == "") {
      let counts = this.compressedText.slice(0, this.caretPosition).split(/([0-9]+)/);
      let index = counts.length;
      this.lower = counts.slice(0, index - 2).filter(v => !Number.isNaN(+v)).reduce((a, b) => (+a + +b), 0);
      this.upper = counts.filter(v => !Number.isNaN(+v)).reduce((a, b) => (+a + +b), 0);
    }
    if (this.exerciseType == "wordCompression") {
      let currentText = this.text.substr(0, this.caretPosition);
      currentText = currentText.substring(0, currentText.lastIndexOf(" "));

      let index = this.compressedText.substr(0, this.caretPosition).split(" ").length - 1;
      if (!this.compressedText.includes(" ")) {
        index = 0;
      }
      console.log(index);
      currentText = this.text.split(" ").slice(0, index).join(" ");
      let currentWord = this.text.split(" ")[currentText.length == 0 ? 0 : currentText.split(" ").length];

      let previousWords = currentText.split(" ")
      console.log(previousWords);

      this.toHighlight = [];

      for (let i = 0; i < currentWord.length + 1; i++) {
        for (let j = i + 3; j < currentWord.length + 1; j++) {
          let prefix = currentWord.substr(i, j);
          if (previousWords.includes(prefix)) {
            if (this.absolute && !this.relative) {
              let start = previousWords.indexOf(prefix);
              this.toHighlight.push(start);
            } else if (!this.absolute && this.relative) {
              this.toHighlight.push(previousWords.lastIndexOf(prefix));
            } else if (this.absolute && this.relative) {
              let start: number = previousWords.indexOf(prefix);
              if (start < previousWords.lastIndexOf(prefix) - index) {
                this.toHighlight.push(start);
              } else {
                this.toHighlight.push(previousWords.lastIndexOf(prefix));
              }
            }
          }
        }
      }
      this.toHighlight.push(index);
    }

    if (this.exerciseType == "wordDecompression") {
      let index = this.text.substr(0, this.caretPosition).split(" ").length - 1;
      this.toHighlight = [];
      this.computeHightlight(index);
    }
    if (this.exerciseType == "letterCompression") {
      this.toHighlight = [this.position[this.caretPosition]];
    }
    if (this.exerciseType == "letterDecompression") {
      this.toHighlight = [this.compressionService.compressLetter(this.studentText.toUpperCase().slice(0, this.caretPosition), this.mapping).length];
    }
  }

  computeHightlight(index: number) {
    let wordsToHighlight: number[] = [index];
    let currentWord = this.compressedText.split(" ")[index];
    let allWords = this.compressedText.split(" ");

    if (currentWord == undefined) {
      return;
    }
    let pieces = currentWord.split(/([#+])/);
    let lastSign = "";
    for (let p of pieces) {
      if (p.charAt(0) == "+" || p.charAt(0) == "#") {
        lastSign = p;
      } else {
        if (lastSign != "") {
          let number = "";
          for (let i = 0; i < p.length; i++) {
            if (!Number.isNaN(+p.charAt(i))) {
              number = number.concat(p.charAt(i));
            }
          }
          if (lastSign == "#") {
            wordsToHighlight.push(+number - 1);
            if (allWords[+number - 1].includes("#") || allWords[+number - 1].includes("+")) {
              this.computeHightlight(+number - 1);
            }
          } else {
            wordsToHighlight.push(index - +number);
            if (allWords[index - +number].includes("#") || allWords[index - +number].includes("+")) {
              this.computeHightlight(index - +number);
            }
          }
        }
        lastSign = "";
      }
    }

    for (let w of wordsToHighlight) {
      this.toHighlight.push(w);
    }
  }

  inCurrent(i: number, j: number) {
    if (this.exerciseType == "newImageCompression") {
      let pixel = i * 20 + j;
      if (pixel >= this.lower && pixel < this.upper) {
        return true;
      } else {
        return false;
      }
    }
    if (this.exerciseType == "imageCompression") {
      return (Math.floor(i / 2) == this.current[0] && Math.floor(j / 2) == this.current[1]);
    }
    if (this.exerciseType == "newImageDecompression") {
      let pixel = this.current[0] * 20 + this.current[1];
      let pos = this.position[i];
      if (this.position[i] > pixel) {
        while (this.position[i] == pos) {
          i--;
        }
        if (i < 0 || this.position[i] <= pixel) {
          return true;
        }
      }
      return false;
    }
  }

  inError(i: number, j: number): boolean {
    for (let e of this.errors) {
      if (i == e[0] && j == e[1]) {
        return true;
      }
    }
    return false;
  }


  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

  autoFill() {
    let filled = 0;

    let solution = "";
    let counts = this.compressedText.split(/([0-9]+)/);

    for (let i = 1; i < counts.length; i += 2) {
      solution = solution.concat(counts[i + 1].repeat(+counts[i]));
    }

    this.image = this.imageSolutionEditor.getImage();

    let baseColor = this.colors == 'bw' ? 'w' : "c";

    this.errors = [].concat(...this.image.map((v, i) => (v.map((u, j) => [u, i, j]).filter(u => u[0] != solution.charAt(+u[1] * 20 + +u[2]) && u[0] != baseColor).map(u => [u[1], u[2]]))));

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
      return;
    }

    let filledPixels = this.image.map((v, i) => (v.map((u, j) => [u, i, j]).filter(u => u[0] == solution.charAt(+u[1] * 20 + +u[2]) && u[0] != baseColor)));
    filledPixels = [].concat(...filledPixels);
    let notCyanPixels = solution.split("").map((v, i) => v != baseColor);
    filled = 1.0 * filledPixels.length / notCyanPixels.length;
    console.log(filled)

    if (filled < 0.3) {
      this.messageService.addAlertWithTimeout(this.get("solveMore"), "info", 10000);
      return;
    } else {
      this.imageSolutionEditor.setImage(solution.match(/.{1,20}/g).map(v => v.split("")));
    }
  }

  selectNode(label: string) {
    if ((this.prefixes.includes(label)) || this.codes.includes(label) || label == "start") {
      return;
    }
    let i = 0;
    while (i < this.mapping.length) {
      if (this.codes[i] == "" || this.codes[i] == undefined) {
        this.mapping[i][2] = label;
        break;
      }
      i++;
    }
    this.computePrefixes();

  }

  changeCode(i: number) {
    this.computePrefixes();
  }

  computePrefixes() {
    this.prefixes = [];
    if (this.greyOut) {
      this.prefixes = [];
      for (let n of this.nodes.map(v => v.id)) {
        for (let c of this.codes) {
          console.log(c);
          if (n.startsWith(c) && c != "") {
            this.prefixes.push(n);
            break;
          }
        }
      }
      console.log(this.prefixes);
    }
  }

  //Compression

  generateWordCompression() {
    this.highlight = Math.random() > 0.5;
    this.absolute = Math.random() > 0.3;
    this.relative = this.absolute ? (Math.random() > 0.8) : true;
    this.generateText();
  }

  generateLetterCompression() {
    this.mapping = [];
    let count = Math.floor(Math.random() * 4) + 4;
    let sum = 0;
    let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    let codes = this.compressionService.getCodes(count);
    for (let i = 0; i < count; i++) {
      let char = alphabet.splice(Math.floor(Math.random() * alphabet.length), 1).toString();
      let code = codes.splice(Math.floor(Math.random() * codes.length), 1);
      this.mapping.push([char, code.toString()]);
    }

    let chars = this.map0;
    let length = Math.ceil(Math.random() * 5) + 5;
    this.text = "";
    for (let i = 0; i < length; i++) {
      this.text = this.text.concat(chars[Math.floor(Math.random() * chars.length)])
    }
    this.normalizeMapping(0);
    this.showTree = Math.random() > 0.5;
  }

  generateCreateCompression() {
    this.mapping = [];
    let count = Math.floor(Math.random() * 4) + 4;
    let sum = 0;
    let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    for (let i = 0; i < count; i++) {
      let char = alphabet.splice(Math.floor(Math.random() * alphabet.length), 1).toString();
      let frequency = Math.ceil((Math.random() * (100 - sum) - 5) / (count - this.mapping.length)) + 5;
      if (this.mapping.length == count - 1) {
        frequency = 100 - sum;
      }
      sum += frequency;
      this.mapping.push([char, frequency]);
    }

    this.mapping.sort((a, b) => (+b[1] - +a[1]));
    this.greyOut = (Math.random() > 0.5);
    this.normalizeMapping(0);
  }

  normalizeMapping(i: number) {
    this.mapping[i][0] = this.mapping[i][0].toUpperCase().replace(/[^A-Z]/gi, "").charAt(0);

    if (this.exerciseType != "createCompression") {
      this.mapping[i][1] = this.mapping[i][1].toUpperCase().replace(/[^01]/gi, "");

      this.normalizeText();
      if (!this.notFilled() && !this.notUnique()) {
        let graph = this.compressionService.computeTree(this.mapping);
        this.nodes = graph.nodes;
        this.edges = graph.edges;
      }
    }

    if (this.exerciseType == "createCompression") {
      this.mapping[i][0] = this.mapping[i][0].toUpperCase().replace(/[^A-Z]/gi, "").charAt(0);
      let sum = this.map1.slice(0, this.map1.length - 1).reduce((a, b) => + a + +b, 0);
      console.log(this.map1);
      this.mapping[this.mapping.length - 1][1] = 100 - sum;
      if (this.map1.filter(v => v == undefined || v == "").length == 0) {
        let graph = this.compressionService.computeTreeBySize(this.mapping);
        this.nodes = graph.nodes;
        this.edges = graph.edges;
      }
    }
  }

  deleteMapping(i: number) {
    this.mapping.splice(i, 1);
    this.normalizeText();
    this.normalizeMapping(0);
    if (!this.notFilled() && !this.notUnique() && this.exerciseType != "createCompression") {
      let graph = this.compressionService.computeTree(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
    }
  }

  notUnique(): boolean {
    if (this.exerciseType != 'createCompression') {
      if (this.map0.filter((v, i) => this.map0.indexOf(v) != i).length > 0 || this.map1.filter((v, i) => this.map1.indexOf(v) != i).length > 0) {
        return true;
      }
      return false;
    } else {
      if (this.map0.filter((v, i) => this.map0.indexOf(v) != i).length > 0) {
        return true;
      }
      return false;
    }
  }

  notFilled(): boolean {
    if (this.exerciseType != 'createCompression') {
      if (this.map1.filter(v => v == undefined || v.trim() == "").length > 0) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  notEnough(): boolean {
    if (this.map0.filter(v => v == undefined || v.trim() == "").length > 0) {
      return true;
    }
    return false;
  }

  notPrefixFree(): boolean {
    for (let i = 0; i < this.map1.length; i++) {
      for (let j = 0; j < i; j++) {
        if (this.map1[i].startsWith(this.map1[j]) || this.map1[j].startsWith(this.map1[i])) {
          return true;
        }
      }
    }
    return false;
  }

  smaller5(): boolean {
    return this.map1.filter(v => +v < 5).length != 0;
  }


  generateText() {
    console.log(this.possibleTexts);
    let index = Math.floor(Math.random() * this.possibleTexts.length);
    this.text = this.possibleTexts[index];
    this.normalizeText();
  }

  normalizeText() {
    this.text = this.text.replace(/[^A-z ]/gi, '').replace(/\s+/gi, ' ').toUpperCase();
    if (this.exerciseType == 'wordDecompression') {
      this.compressedText = this.compressionService.compress(this.text, this.absolute, this.relative);;
    }
    if (this.exerciseType == 'letterCompression') {
      let allowed = this.mapping.map(v => v[0]);
      if (this.text) {
        this.text = this.text.replace(new RegExp("[^" + allowed + "]", 'gi'), '').replace(/\s+/gi, ' ').toUpperCase();
        this.position = [];
        let index = 0;
        let map0 = this.mapping.map(v => v[0]);
        for (let c of this.text) {
          let i = map0.indexOf(c);
          for (let j = 0; j < this.mapping[i][1].length; j++) {
            this.position.push(index);
          }
          index++;
        }
      }
    }
    if (this.exerciseType == 'letterDecompression') {
      this.compressedText = this.compressionService.compressLetter(this.text, this.mapping);
    }
  }

  normalizeTextStudent() {
    this.studentText = this.studentText.replace(/[^A-z ]/gi, '').replace(/\s+/gi, ' ').toUpperCase();
    if (this.exerciseType == "letterDecompression") {
      let allowed = this.mapping.map(v => v[0]);
      this.studentText = this.studentText.replace(new RegExp("[^" + allowed + "]", 'gi'), '').replace(/\s+/gi, ' ').toUpperCase();
    }
  }

  normalizeTextCompressed() {
    this.compressedText = this.compressedText.replace(/[^A-z #0-9+]/gi, '').replace(/\s+/gi, ' ').toUpperCase();
  }

  getMethodDescription(): string {
    switch (this.exerciseType) {
      case "imageCompression": return this.get("imageCompressionDescription").concat(this.colors == 'bw' ? this.get("useColorTable") : ""); 
      case "newImageCompression": return this.get("newImageCompressionDescription"); ;
      case "newImageDecompression": return this.get("newImageDecompressionDescription"); ;
      case "createImages": return this.requirement; ;
      case "wordCompression": let result = this.get("wordCompressionDescription");
        if (this.absolute && !this.relative) {
          result = result.concat(this.get("wordCompressionAbsoluteDescription"));
        } else if (!this.absolute && this.relative) {
          result = result.concat(this.get("wordCompressionRelativeDescription"));
        } else {
          result = result.concat(this.get("wordCompressionAbsoluteRelativeDescription"));
        }
        return result; ;
      case "wordDecompression": return this.get("wordDecompressionDescription"); ;
      case "letterCompression": return this.get("letterCompressionDescription"); ;
      case "letterDecompression": return this.get("letterDecompressionDescription"); ;
      case "createCompression": return this.get("createCompressionDescription"); ;
    }
  }

  checkSolution() {
    switch (this.exerciseType) {
      case "imageCompression": this.checkSolutionImageCompression(); break;
      case "newImageCompression": this.checkSolutionNewImageCompression(); break;
      case "newImageDecompression": this.checkSolutionNewImageDecompression(); break;
      case "createImages": this.checkSolutionCreateImages(); break;
      case "wordCompression": this.checkSolutionWordCompression(); break;
      case "wordDecompression": this.checkSolutionWordDecompression(); break;
      case "letterCompression": this.checkSolutionLetterCompression(); break;
      case "letterDecompression": this.checkSolutionLetterDecompression(); break;
      case "createCompression": this.checkSolutionCreateCompression(); break;
    }
  }




}